import {
  ARIcon,
  DownloadImageIcon,
  DownloadModelIcon,
} from "@/shared/presentation/components/ToolbarIcons";
import { Loc, t } from "@/locales";
import type { ARStatus } from "@/configurator/presentation/useARPresentationComponent";

type Props = {
  arStatus: ARStatus;
  arError: string | null;
  onOpenAR: () => void;
  onDownloadModel: () => void;
  onDownloadImage: () => void;
};

function arLabel(status: ARStatus) {
  if (status === "preparing") return t(Loc.arPreparing);
  if (status === "presenting") return t(Loc.arExit);
  return t(Loc.arOpen);
}

export function ModelToolbar(props: Props) {
  return (
    <div className="model-toolbar">
      <button
        type="button"
        className="model-toolbar__item"
        onClick={props.onDownloadModel}
      >
        <DownloadModelIcon className="model-toolbar__icon" />
        <span className="model-toolbar__label">{t(Loc.downloadModel)}</span>
      </button>

      <button
        type="button"
        className="model-toolbar__item"
        onClick={props.onOpenAR}
        disabled={props.arStatus === "preparing"}
      >
        <ARIcon className="model-toolbar__icon" />
        <span className="model-toolbar__label">{arLabel(props.arStatus)}</span>
      </button>

      <button
        type="button"
        className="model-toolbar__item"
        onClick={props.onDownloadImage}
      >
        <DownloadImageIcon className="model-toolbar__icon" />
        <span className="model-toolbar__label">{t(Loc.downloadImage)}</span>
      </button>

      {props.arError ? (
        <div className="model-toolbar__error" role="status">
          {props.arError}
        </div>
      ) : null}
    </div>
  );
}
